import React, { useState, useEffect } from "react";
import logo from "../../src/assets/images/logo.png"; // Adjust the path as necessary

const LoadingScreen = () => {
  const [messageIndex, setMessageIndex] = useState(0);

  const messages = [
    "We are loading for you...",
    "Syncing employee records...",
    "Fetching performance analytics...",
    "Calculating payroll insights...",
    "Optimizing workflow data...",
    "Preparing your dashboard...",
    "Securing confidential data...",
    "Validating session tokens...",
    "Loading organizational structure...",
    "Retrieving leave requests...",
    "Aligning team OKRs...",
    "Compiling 360-degree feedback...",
    "Updating skill matrices...",
    "Processing tax deductions...",
    "Checking compliance policies...",
    "Almost there..."
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }, 1000); // Change text every 2 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={styles.container}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes fadeText {
            0% { opacity: 0; transform: translateY(10px); }
            100% { opacity: 1; transform: translateY(0px); }
          }
        `}
      </style>
      
      <div style={styles.loaderBox}>
        {/* The Spinning Ring */}
        <div style={styles.spinner}></div>
        
        {/* The Static Logo in the center */}
        <img src={logo} alt="Logo" style={styles.logo} />
      </div>

      {/* Dynamic Text Section */}
      <div style={styles.textContainer}>
        <p key={messageIndex} style={styles.loadingText}>
          {messages[messageIndex]}
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "column", // Stack spinner and text vertically
    alignItems: "center",
    justifyContent: "center",
    // background: "#1a1a2e",
    color: "#fff",
    fontFamily: "sans-serif",
  },
  loaderBox: {
    position: "relative",
    width: "120px",
    height: "120px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "24px", // Space between spinner and text
  },
  spinner: {
    position: "absolute",
    width: "100%",
    height: "100%",
    border: "3px solid transparent",
    borderTopColor: "#8DC63F", // Your lime green
    borderRightColor: "#8DC63F", 
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  logo: {
    width: "60px",
    height: "auto",
    zIndex: 2,
  },
  textContainer: {
    height: "30px", // Fixed height prevents layout jumping
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loadingText: {
    margin: 0,
    fontSize: "1rem",
    fontWeight: "400",
    letterSpacing: "1px",
    color: "#151525", // Matches your spinner color
    animation: "fadeText 0.5s ease-out forwards",
  }
};

export default LoadingScreen;